"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDataSourceSupportedInputs = exports.ImportStatus = exports.DataSourceCode = exports.DataSourceType = void 0;
var DataSourceType;
(function (DataSourceType) {
    DataSourceType["Exchange"] = "exchange";
    DataSourceType["Blockchain"] = "blockchain";
    DataSourceType["Wallet"] = "wallet";
    DataSourceType["Custom"] = "custom";
    DataSourceType["Import"] = "import";
})(DataSourceType = exports.DataSourceType || (exports.DataSourceType = {}));
// data source names
var DataSourceCode;
(function (DataSourceCode) {
    // exchanges
    DataSourceCode["AmberApp"] = "amberapp";
    DataSourceCode["Ascendex"] = "ascendex";
    DataSourceCode["Bamboo"] = "bamboo";
    DataSourceCode["BTCC"] = "btcc";
    DataSourceCode["Binance"] = "Binance";
    DataSourceCode["BingX"] = "bingx";
    DataSourceCode["Bitaroo"] = "Bitaroo";
    DataSourceCode["Bitbns"] = "Bitbns";
    DataSourceCode["Bitfinex"] = "Bitfinex";
    DataSourceCode["Bitget"] = "bitget";
    DataSourceCode["Bitkub"] = "Bitkub";
    DataSourceCode["BitMart"] = "BitMart";
    DataSourceCode["BitMEX"] = "Bitmex";
    DataSourceCode["Bitrue"] = "bitrue";
    DataSourceCode["Bitstamp"] = "Bitstamp";
    DataSourceCode["BitTrade"] = "bit_trade";
    DataSourceCode["BitTrex"] = "BitTrex";
    DataSourceCode["Bitunix"] = "bitunix";
    DataSourceCode["BlockchainDotCom"] = "blockchaincom";
    DataSourceCode["BlockFi"] = "BlockFi";
    DataSourceCode["BlockEarner"] = "block_earner";
    DataSourceCode["BTCE"] = "BTCE";
    DataSourceCode["BtcMarkets"] = "BTCMarkets";
    DataSourceCode["Bybit"] = "bybit";
    DataSourceCode["CalebBrown"] = "caleb_and_brown";
    DataSourceCode["Celsius"] = "Celsius";
    DataSourceCode["Cex"] = "Cexio";
    DataSourceCode["Coinbase"] = "Coinbase";
    DataSourceCode["CoinbasePro"] = "coinbase_pro";
    DataSourceCode["CoinbasePrime"] = "coinbase-prime";
    DataSourceCode["CoinEx"] = "CoinEx";
    DataSourceCode["CoinHarbour"] = "CoinHarbour";
    DataSourceCode["CoinJar"] = "CoinJar";
    DataSourceCode["CoinJarExchange"] = "CoinJarExchange";
    DataSourceCode["Cointree"] = "Cointree";
    DataSourceCode["CoinSpot"] = "CoinSpot";
    DataSourceCode["CoinStash"] = "CoinStash";
    DataSourceCode["CryptoDotCom"] = "Crypto.com";
    DataSourceCode["CryptoDotComExchange"] = "crypto_com_exchange";
    DataSourceCode["Cryptohopper"] = "cryptohopper";
    DataSourceCode["CryptoSpend"] = "cryptospend";
    DataSourceCode["DeltaExchange"] = "delta_spot";
    DataSourceCode["Degate"] = "degate";
    DataSourceCode["DigitalSurge"] = "DigitalSurge";
    DataSourceCode["Elbaite"] = "elbaite";
    DataSourceCode["Ember"] = "emberfund";
    DataSourceCode["EtherDelta"] = "etherdelta";
    DataSourceCode["EToro"] = "etoro";
    DataSourceCode["Finblox"] = "finblox";
    DataSourceCode["FinderEarn"] = "finder_earn";
    DataSourceCode["FTX"] = "FTX";
    DataSourceCode["Gateio"] = "Gateio";
    DataSourceCode["Gemini"] = "Gemini";
    DataSourceCode["GPIB"] = "gpib";
    DataSourceCode["HardBlock"] = "hardblock";
    DataSourceCode["HitBTC"] = "HitBTC";
    DataSourceCode["HTX"] = "huobi";
    DataSourceCode["IGMarkets"] = "ig_markets";
    DataSourceCode["IndependentReserve"] = "IndependentReserve";
    DataSourceCode["KinesisMoney"] = "kinesis_money";
    DataSourceCode["Kraken"] = "Kraken";
    DataSourceCode["KuCoin"] = "KuCoin";
    DataSourceCode["Ledn"] = "ledn";
    DataSourceCode["LROS"] = "living_room_of_satoshi";
    DataSourceCode["Luno"] = "Luno";
    DataSourceCode["Mercatox"] = "mercatox";
    DataSourceCode["MEXC"] = "mexc";
    DataSourceCode["MoonPay"] = "moonpay";
    DataSourceCode["Nexo"] = "nexo";
    DataSourceCode["NexoPro"] = "nexo-pro";
    DataSourceCode["NiceHash"] = "NiceHash";
    DataSourceCode["OKX"] = "OKEX";
    DataSourceCode["Paxful"] = "paxful";
    DataSourceCode["Phemex"] = "phemex";
    DataSourceCode["Pionex"] = "pionex";
    DataSourceCode["Poloniex"] = "Poloniex";
    DataSourceCode["PrimeXBT"] = "primexbt";
    DataSourceCode["SafeTrade"] = "SafeCoin";
    DataSourceCode["SouthXChange"] = "south_xchange";
    DataSourceCode["Swyftx"] = "Swyftx";
    DataSourceCode["TradeOgre"] = "trade_ogre";
    DataSourceCode["Uphold"] = "uphold";
    DataSourceCode["Virgo"] = "virgo";
    DataSourceCode["Wealth99"] = "wealth99";
    DataSourceCode["WooX"] = "wootrade";
    DataSourceCode["Xeggex"] = "xeggex";
    DataSourceCode["XTDotCom"] = "xtpub";
    DataSourceCode["YieldApp"] = "yield_app";
    DataSourceCode["YouHodler"] = "you_hodler";
    DataSourceCode["CoinList"] = "coinlist";
    DataSourceCode["CoinListPro"] = "coinlist-pro";
    DataSourceCode["RelayPay"] = "relay-pay";
    DataSourceCode["Deribit"] = "deribit";
    DataSourceCode["Zerocap"] = "zerocap";
    DataSourceCode["Strike"] = "strike";
    DataSourceCode["Stormrake"] = "stormrake";
    DataSourceCode["Whitebit"] = "whitebit";
    DataSourceCode["Coinstore"] = "coinstore";
    DataSourceCode["Revolut"] = "revolut";
    DataSourceCode["UpTrade"] = "uptrade";
    DataSourceCode["Lbank"] = "LBank";
    DataSourceCode["PocketBits"] = "pocketbits";
    DataSourceCode["Changelly"] = "changelly";
    DataSourceCode["CoinDCX"] = "coindcx";
    DataSourceCode["Bitcoincomau"] = "bitcoincomau";
    DataSourceCode["Txbit"] = "txbit";
    DataSourceCode["Coinmetro"] = "coin_metro";
    DataSourceCode["OceanEx"] = "oceanex";
    DataSourceCode["LCX"] = "lcx";
    DataSourceCode["MtGox"] = "MtGox";
    DataSourceCode["Idex"] = "IDEX";
    DataSourceCode["CoinBene"] = "CoinBene";
    DataSourceCode["Bitgo"] = "bitgo";
    DataSourceCode["Toobit"] = "toobit";
    DataSourceCode["Coinmama"] = "coinmama";
    DataSourceCode["Bitpanda"] = "bitpanda-exchange";
    // wallets
    DataSourceCode["Mintscan"] = "mintscan";
    DataSourceCode["Qoin"] = "qoin";
    DataSourceCode["Vera"] = "Vera";
    DataSourceCode["GalaxyStation"] = "galaxy-station";
    DataSourceCode["TerraStation"] = "terra-station";
    DataSourceCode["NeonWallet"] = "neon_wallet";
    // bitcoin wallets
    DataSourceCode["BlueWallet"] = "blue-wallet";
    DataSourceCode["SparrowWallet"] = "sparrow-wallet";
    DataSourceCode["Electrum"] = "electrum";
    DataSourceCode["Mycelium"] = "mycelium";
    DataSourceCode["ColdCard"] = "coldcard";
    DataSourceCode["JadeWallet"] = "jade-wallet";
    DataSourceCode["GreenWallet"] = "green-wallet";
    DataSourceCode["PassportWallet"] = "passport-wallet";
    // multi-chain wallets
    DataSourceCode["Ledger"] = "Ledger";
    DataSourceCode["Bitfi"] = "bitfi";
    DataSourceCode["Trezor"] = "trezor";
    DataSourceCode["Dcent"] = "dcent";
    DataSourceCode["OneKey"] = "onekey";
    DataSourceCode["TrustWallet"] = "trust_wallet";
    DataSourceCode["AtomicWallet"] = "atomic_wallet";
    DataSourceCode["Exodus"] = "Exodus";
    DataSourceCode["Bitbox"] = "bitbox";
    DataSourceCode["MyEtherWallet"] = "MyEtherWallet";
    DataSourceCode["RabbyWallet"] = "rabby_wallet";
    DataSourceCode["CoinbaseWallet"] = "coinbase_wallet";
    DataSourceCode["Coinomi"] = "coinomi";
    DataSourceCode["Jaxx"] = "jaxx_liberty";
    DataSourceCode["Bifrost"] = "bifrost_wallet";
    DataSourceCode["Guarda"] = "guarda_wallet";
    DataSourceCode["BitgetWallet"] = "bitget-wallet";
    DataSourceCode["Tangem"] = "tangem";
    DataSourceCode["Vultisig"] = "vultisig";
    DataSourceCode["SafepalWallet"] = "safepal_wallet";
    DataSourceCode["Enkrypt"] = "enkrypt";
    DataSourceCode["CryptoComWallet"] = "crypto-com-wallet";
    DataSourceCode["BinanceWallet"] = "binance-wallet";
    DataSourceCode["OkxWallet"] = "okx-wallet";
    DataSourceCode["KeepKey"] = "keepkey";
    DataSourceCode["BlockchainDotComWallet"] = "blockchaincom-wallet";
    DataSourceCode["CoolWallet"] = "coolwallet";
    DataSourceCode["Zelcore"] = "zelcore";
    DataSourceCode["Kasware"] = "kasware";
    // evm wallets
    DataSourceCode["Metamask"] = "Metamask";
    DataSourceCode["Etherscan"] = "Etherscan";
    DataSourceCode["Rainbow"] = "rainbow_wallet";
    DataSourceCode["OneInchWallet"] = "oneinch_wallet";
    DataSourceCode["InternetMoney"] = "internet-money";
    // ripple wallets
    DataSourceCode["Xaman"] = "xaman";
    DataSourceCode["ToastWallet"] = "toast_wallet";
    DataSourceCode["RippexWallet"] = "rippex_wallet";
    // stellar wallets
    DataSourceCode["StellarPort"] = "stellarport";
    DataSourceCode["RabetWallet"] = "rabet_wallet";
    DataSourceCode["xBullWallet"] = "xbull_wallet";
    DataSourceCode["Lobstr"] = "lobstr";
    // solana wallets
    DataSourceCode["Solflare"] = "solflare";
    DataSourceCode["Phantom"] = "phantom";
    // hedera wallet
    DataSourceCode["HashPack"] = "hashpack";
    DataSourceCode["Wallawallet"] = "wallawallet";
    DataSourceCode["Yamgo"] = "yamgo";
    DataSourceCode["MyHbarWallet"] = "myhbarwallet";
    DataSourceCode["Kabila"] = "kabila";
    DataSourceCode["BladeWallet"] = "blade-wallet";
    // cardano wallets
    DataSourceCode["Daedalus"] = "daedalus";
    DataSourceCode["Yoroi"] = "yoroi";
    DataSourceCode["Nami"] = "nami";
    DataSourceCode["Adalite"] = "adalite";
    DataSourceCode["BeginWallet"] = "begin_wallet";
    DataSourceCode["Typhon"] = "typhon";
    DataSourceCode["Vespr"] = "vespr";
    DataSourceCode["Lace"] = "lace";
    DataSourceCode["Eternl"] = "eternl";
    DataSourceCode["Flint"] = "flint";
    DataSourceCode["GeroWallet"] = "gerowallet";
    // blockchains
    DataSourceCode["Algorand"] = "algorand";
    DataSourceCode["AvalancheXChain"] = "avalanche-x-chain";
    DataSourceCode["BloFin"] = "blofin";
    DataSourceCode["CasperNetwork"] = "casper-network";
    DataSourceCode["Elastos"] = "elastos";
    DataSourceCode["Vechain"] = "vechain";
    DataSourceCode["Cardano"] = "Cardano";
    DataSourceCode["Oraichain"] = "oraichain";
    DataSourceCode["Flare"] = "flare";
    DataSourceCode["Flow"] = "flow";
    DataSourceCode["HederaHashgraph"] = "hedera-hashgraph";
    DataSourceCode["Harmony"] = "harmony";
    DataSourceCode["Helium"] = "Helium";
    DataSourceCode["Kaspa"] = "kasplex";
    DataSourceCode["ICON"] = "icon";
    DataSourceCode["InternetComputer"] = "internet-computer";
    DataSourceCode["EnergyWeb"] = "energy-web";
    DataSourceCode["NearProtocol"] = "near-protocol";
    DataSourceCode["MinaProtocol"] = "mina-protocol";
    DataSourceCode["MultiversX"] = "multiversx";
    DataSourceCode["SeiNetwork"] = "sei-network";
    DataSourceCode["Solana"] = "solana";
    DataSourceCode["Songbird"] = "songbird";
    DataSourceCode["Stacks"] = "stacks";
    DataSourceCode["Stellar"] = "stellar";
    DataSourceCode["Sui"] = "sui";
    DataSourceCode["Symbol"] = "symbol";
    DataSourceCode["Tezos"] = "tezos";
    DataSourceCode["NeoLegacy"] = "neo";
    DataSourceCode["NeoN3"] = "neo-n3";
    DataSourceCode["Zilliqa"] = "zilliqa";
    DataSourceCode["Ton"] = "ton";
    DataSourceCode["Thorchain"] = "thorchain";
    DataSourceCode["Tron"] = "tron";
    DataSourceCode["XRP"] = "xrp";
    DataSourceCode["Nano"] = "nano";
    DataSourceCode["Eos"] = "eos";
    DataSourceCode["Theta"] = "theta-network";
    DataSourceCode["Terra"] = "terra-two";
    DataSourceCode["TerraClassic"] = "terra";
    DataSourceCode["Cosmos"] = "cosmos";
    DataSourceCode["Agoric"] = "agoric";
    DataSourceCode["Akash"] = "akash";
    DataSourceCode["Althea"] = "althea";
    DataSourceCode["Archway"] = "archway";
    DataSourceCode["Atomone"] = "atomone";
    DataSourceCode["Axelar"] = "axelar";
    DataSourceCode["Band"] = "band";
    DataSourceCode["Bitsong"] = "bitsong";
    DataSourceCode["Celestia"] = "celestia";
    DataSourceCode["Chihuahua"] = "chihuahua";
    DataSourceCode["Coreum"] = "coreum";
    DataSourceCode["CronosPos"] = "crypto-org";
    DataSourceCode["DyDxChain"] = "dydx-chain";
    DataSourceCode["Dymension"] = "dymension";
    DataSourceCode["Evmos"] = "evmos";
    DataSourceCode["FetchAi"] = "fetchai";
    DataSourceCode["Finschia"] = "finschia";
    DataSourceCode["Govgen"] = "govgen";
    DataSourceCode["GravityBridge"] = "gravity-bridge";
    DataSourceCode["HumansAi"] = "humans";
    DataSourceCode["Injective"] = "injective-chain";
    DataSourceCode["Iris"] = "iris";
    DataSourceCode["Kava"] = "kava";
    DataSourceCode["Mantra"] = "mantra";
    DataSourceCode["Medibloc"] = "medibloc";
    DataSourceCode["Milkyway"] = "milkyway";
    DataSourceCode["Neutron"] = "neutron";
    DataSourceCode["Noble"] = "noble";
    DataSourceCode["Omniflix"] = "omniflix";
    DataSourceCode["OnomyProtocol"] = "onomy-protocol";
    DataSourceCode["Osmosis"] = "osmosis";
    DataSourceCode["Persistence"] = "persistence";
    DataSourceCode["Quasar"] = "quasar";
    DataSourceCode["Regen"] = "regen";
    DataSourceCode["Saga"] = "saga";
    DataSourceCode["Secret"] = "secret";
    DataSourceCode["Sei"] = "sei";
    DataSourceCode["Selfchain"] = "selfchain";
    DataSourceCode["Sentinel"] = "sentinel";
    DataSourceCode["Shentu"] = "shentu";
    DataSourceCode["Sommelier"] = "sommelier";
    DataSourceCode["StaFi"] = "stafi";
    DataSourceCode["Stargaze"] = "stargaze";
    DataSourceCode["Stride"] = "stride";
    DataSourceCode["Xion"] = "xion";
    DataSourceCode["Xpla"] = "xpla";
    DataSourceCode["Zetachain"] = "zeta";
    DataSourceCode["Iotex"] = "iotex";
    DataSourceCode["Juno"] = "juno";
    DataSourceCode["KyveNetwork"] = "kyve-network";
    DataSourceCode["Nolus"] = "nolus";
    DataSourceCode["Wax"] = "wax";
    DataSourceCode["Ultra"] = "ultra";
    DataSourceCode["NEM"] = "nem";
    DataSourceCode["Monero"] = "monero";
    DataSourceCode["Aptos"] = "aptos";
    DataSourceCode["BeaconChain"] = "beacon-chain";
    DataSourceCode["Kusama"] = "kusama";
    DataSourceCode["KuCoinCommunityChain"] = "kucoin-community-chain";
    DataSourceCode["Beldex"] = "beldex";
    DataSourceCode["Hyperliquid"] = "hyperliquid";
    DataSourceCode["XprNetwork"] = "xpr-network";
    DataSourceCode["WavesBlockchain"] = "waves";
    DataSourceCode["WavesExchange"] = "wx-network";
    DataSourceCode["Filecoin"] = "filecoin";
    DataSourceCode["Horizon"] = "horizon";
    DataSourceCode["Wanchain"] = "wanchain";
    DataSourceCode["Ronin"] = "ronin";
    DataSourceCode["PiNetwork"] = "pi-network";
    DataSourceCode["Firo"] = "firo";
    DataSourceCode["Ravencoin"] = "ravencoin";
    DataSourceCode["PIVX"] = "pivx";
    DataSourceCode["Core"] = "core";
    DataSourceCode["Aleo"] = "aleo";
    DataSourceCode["IronFish"] = "iron-fish";
    // Chrysalis, Stardust and Rebased are all sort of the 'modern' iota and share similar address format.
    // However, each has a different block explorer used, so we also need to represent them distinctly.
    DataSourceCode["IotaLegacy"] = "iota-legacy";
    DataSourceCode["IotaChrysalis"] = "iota-chrysalis";
    DataSourceCode["IotaStardust"] = "iota-stardust";
    DataSourceCode["IotaRebased"] = "iota-rebased";
    // Bitcoin-like chains
    DataSourceCode["Bitcoin"] = "Bitcoin";
    DataSourceCode["BitcoinCash"] = "bitcoinCash";
    DataSourceCode["BitcoinSv"] = "bitcoin-sv";
    DataSourceCode["ECash"] = "eCash";
    DataSourceCode["Litecoin"] = "litecoin";
    DataSourceCode["Dash"] = "dash";
    DataSourceCode["Dogecoin"] = "dogecoin";
    DataSourceCode["Zcash"] = "zcash";
    DataSourceCode["DigiByte"] = "digibyte";
    DataSourceCode["Groestlcoin"] = "groestlcoin";
    // Polkadot and parachains
    DataSourceCode["Polkadot"] = "polkadot";
    DataSourceCode["Acala"] = "acala";
    DataSourceCode["Astar"] = "astar";
    DataSourceCode["Enjin"] = "enjin";
    DataSourceCode["VaraNetwork"] = "vara-network";
    // EVM chains
    DataSourceCode["Arbitrum"] = "arbitrum";
    DataSourceCode["Avalanche"] = "avalanche";
    DataSourceCode["Beam"] = "beam";
    DataSourceCode["Blast"] = "blast";
    DataSourceCode["Chiliz"] = "chiliz_chain";
    DataSourceCode["Cyber"] = "cyber";
    DataSourceCode["DefiKingdoms"] = "defi_kingdoms_chain";
    DataSourceCode["Base"] = "base";
    DataSourceCode["BinanceSmartChain"] = "binance_smart_chain";
    DataSourceCode["Celo"] = "celo";
    DataSourceCode["Cronos"] = "cronos_evm";
    DataSourceCode["Ethereum"] = "Ethereum";
    DataSourceCode["Fraxtal"] = "fraxtal";
    DataSourceCode["Fantom"] = "fantom";
    DataSourceCode["Gnosis"] = "gnosis_chain";
    DataSourceCode["Linea"] = "linea";
    DataSourceCode["Mantle"] = "mantle";
    DataSourceCode["Memecore"] = "memecore";
    DataSourceCode["Metis"] = "metis";
    DataSourceCode["Mint"] = "mint_chain";
    DataSourceCode["Mode"] = "mode_network";
    DataSourceCode["Moonbeam"] = "moonbeam";
    DataSourceCode["Optimism"] = "optimism";
    DataSourceCode["Polygon"] = "polygon";
    DataSourceCode["Scroll"] = "scroll";
    DataSourceCode["Taiko"] = "taiko";
    DataSourceCode["ZkSyncEra"] = "zksync_era";
    DataSourceCode["Zora"] = "zora_chain";
    DataSourceCode["BnbBeaconChain"] = "bnb_beacon_chain";
    DataSourceCode["opBNB"] = "opbnb";
    DataSourceCode["RedbellyNetwork"] = "redbelly-network";
    DataSourceCode["Morph"] = "morph-l2";
    DataSourceCode["Nibiru"] = "nibiru";
    DataSourceCode["Wyzth"] = "wyzth";
    DataSourceCode["Kroma"] = "kroma";
    DataSourceCode["XDC"] = "xdc-network";
    DataSourceCode["Xai"] = "xai";
    DataSourceCode["WorldChain"] = "world-chain";
    DataSourceCode["WemixNetwork"] = "wemix-network";
    DataSourceCode["Unichain"] = "unichain";
    DataSourceCode["Sophon"] = "sophon";
    DataSourceCode["Sonic"] = "sonic";
    DataSourceCode["PolygonZkEvm"] = "polygon-zkevm";
    DataSourceCode["Moonriver"] = "moonriver";
    DataSourceCode["BitTorrent"] = "bittorrent";
    DataSourceCode["Berachain"] = "berachain";
    DataSourceCode["ArbitrumNova"] = "arbitrum-nova";
    DataSourceCode["ApeChain"] = "apechain";
    DataSourceCode["Abstract"] = "abstract";
    DataSourceCode["Dexalot"] = "dexalot";
    DataSourceCode["Teleporter1"] = "teleporter-1";
    DataSourceCode["Teleporter2"] = "teleporter-2";
    DataSourceCode["Coqnet"] = "coqnet";
    DataSourceCode["StraitsX"] = "straitsx";
    DataSourceCode["Omni"] = "omni-network";
    DataSourceCode["Tiltyard"] = "tiltyard";
    DataSourceCode["GUNZ"] = "gunz";
    DataSourceCode["HighOctane"] = "high-octane";
    DataSourceCode["Corn"] = "corn";
    DataSourceCode["QChain"] = "qchain";
    DataSourceCode["Playdapp"] = "playdapp";
    DataSourceCode["SwanChain"] = "swan-chain";
    DataSourceCode["UPTN"] = "uptn";
    DataSourceCode["Ethernity"] = "ethernity";
    DataSourceCode["Funki"] = "funki";
    DataSourceCode["Superseed"] = "superseed";
    DataSourceCode["Polynomial"] = "polynomial";
    DataSourceCode["Swellchain"] = "swellchain";
    DataSourceCode["Bitrock"] = "bitrock";
    DataSourceCode["Donatuz"] = "donatuz";
    DataSourceCode["Lisk"] = "lisk";
    DataSourceCode["Ink"] = "ink";
    DataSourceCode["Pulsar"] = "pulsar";
    DataSourceCode["Lamina1"] = "lamina1";
    DataSourceCode["DOS"] = "dos-chain";
    DataSourceCode["Orderly"] = "orderly-network";
    DataSourceCode["Kinto"] = "kinto";
    DataSourceCode["Playa3ull"] = "playa3ull";
    DataSourceCode["Shrapnel"] = "shrapnel";
    DataSourceCode["Numbers"] = "numbers";
    DataSourceCode["XANAChain"] = "xana-chain";
    DataSourceCode["Ancient8"] = "ancient8";
    DataSourceCode["PulseChain"] = "pulsechain";
    DataSourceCode["StratisEvm"] = "stratis-evm";
    DataSourceCode["IotaEvm"] = "iota-evm";
    DataSourceCode["LoopNetwork"] = "loopnetwork";
    DataSourceCode["NeoX"] = "neo-x";
    DataSourceCode["Electroneum"] = "electroneum";
    DataSourceCode["Degen"] = "degen";
    DataSourceCode["XrplEvm"] = "xrpl-evm";
    DataSourceCode["Lumia"] = "lumia";
    DataSourceCode["Mixin"] = "mixin";
    DataSourceCode["FlowEvm"] = "evm-on-flow";
    DataSourceCode["ElastosSmartContractChain"] = "elastos-smart-contract-chain";
    DataSourceCode["EthereumClassic"] = "ethereum_classic";
    DataSourceCode["KardiaChain"] = "kardiachain";
    DataSourceCode["GateChain"] = "gatechain";
    DataSourceCode["GoChain"] = "gochain";
    DataSourceCode["LayerK"] = "layerk";
    DataSourceCode["HyperEvm"] = "hyperevm";
    DataSourceCode["Monad"] = "monad";
    DataSourceCode["Katana"] = "katana-evm";
    DataSourceCode["SeiEvm"] = "sei-v2";
    DataSourceCode["Plasma"] = "plasma";
    DataSourceCode["MegaEth"] = "megaeth";
    DataSourceCode["EthereumPow"] = "ethereumpow";
    // others
    DataSourceCode["OpeningBalances"] = "sylaOpeningBalances";
    DataSourceCode["Koinly"] = "koinly";
    DataSourceCode["CoinTracking"] = "cointracking";
    DataSourceCode["CoinStats"] = "coinstats";
    DataSourceCode["Summ"] = "summ";
})(DataSourceCode = exports.DataSourceCode || (exports.DataSourceCode = {}));
var ImportStatus;
(function (ImportStatus) {
    ImportStatus["Off"] = "off";
    ImportStatus["Alpha"] = "alpha";
    ImportStatus["Beta"] = "beta";
    ImportStatus["Gold"] = "gold";
})(ImportStatus = exports.ImportStatus || (exports.ImportStatus = {}));
const getDataSourceSupportedInputs = ({ fileImportStatus, syncImportStatus, }) => ({
    file: (fileImportStatus !== null && fileImportStatus !== void 0 ? fileImportStatus : "off") === "off" ? undefined : fileImportStatus,
    sync: (syncImportStatus !== null && syncImportStatus !== void 0 ? syncImportStatus : "off") === "off" ? undefined : syncImportStatus,
});
exports.getDataSourceSupportedInputs = getDataSourceSupportedInputs;
